// extracted by mini-css-extract-plugin
export var mDown = "Media-module--m-down--72552";
export var mUp = "Media-module--m-up--c7bba";
export var sDown = "Media-module--s-down--35b35";
export var sUp = "Media-module--s-up--1cb87";